import type { UpsellBannerStore } from './interfaces'

export const actions = {
  setBanner (this: UpsellBannerStore, payload: UpsellBannerStore['banner']): void {
    this.banner = payload
  },
  setLoading (this: UpsellBannerStore, payload: UpsellBannerStore['loading']): void {
    this.loading = payload
  },
}
